<template>
  <div class="form-control relative">
    <label
      class="block"
      :class="[themes_labes[theme]]"
      :for="name"
      v-if="label"
    >
      <span v-html="label"></span>
     <span v-if="required" class="obligatoire">*</span>
    </label>
    
    <input
      autocomplete="off"
      class="border border-grey rounded w-full p-3 text-grey-darker leading focus:outline-none focus:bg-white"
      :class="[
        themes[theme],
        { 'font-mono': monospaced, form__error: hasError }
      ]"
      :id="name"
      :name="name"
      :type="type"
      :step="step"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :autofocus="autofocus"
      min="0"
      :max=max
    />
    <span
      v-if="icon"
      class="form-control--icon absolute pin-t pin-r w-11 h-11 bg-center bg-no-repeat"
      :style="{ backgroundImage: 'url(\'' + icon + '\')' }"
    ></span>
    <span
      v-if="icon2"
      class="form-control--icon2 absolute w-11 bg-grey-lighter rounded-l text-blue text-center leading-middel"
      ><i class="fab" :class="icon2"></i
    ></span>

    <div class="form-control--meta" v-if="help || errorMessage">
      <div class="form__help">
        <span v-if="help" v-html="help"></span>
        <span
          v-if="errorMessage"
          class="form-error--message"
          v-html="errorMessage"
        ></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sp-input",
  data() {
    return {
      themes: {
        default: "mb-5",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        team:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight mb-5",
        "team-i":
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight pl-14 mb-5"
      },
      themes_labes: {
        default: "mb-4",
        form: "text-blue text-2sm mb-4",
        team: "text-blue text-2sm font-bold mb-3",
        "team-i": "text-blue text-2sm font-bold mb-3"
      }
    };
  },

  props: {
    name: String,
    placeholder: String,
    label: String,
    help: String,
    icon: String,
    icon2: String,
    max: {
      type: [String, Number],
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    step:{
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    monospaced: {
      type: Boolean,
      default: false
    },
    hasError: {
      required: false,
      type: Boolean,
      default: false
    },
    errorMessage: {
      required: false,
      type: String,
      default: ""
    },
    autocomplete: {
      required: false,
      type: String,
      default: ""
    },
    autofocus: {
      required: false,
      type: Boolean,
      default: false
    },
    theme: {
      required: false,
      type: String,
      default: ""
    }
  }
};
</script>
